module.exports = __webpack_public_path__ + "img/GEM1.3a59f089.png";